import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { MeetingType } from '../../../types'
import { meetingTagUiProps } from './meetingTag.uiprops'
import { PerTag } from '../Tag'

interface Props {
  type: MeetingType
}

export const MeetingTag: FC<Props> = ({ type }) => {
  const { t } = useTranslation()
  const { tagColor, tagName } = meetingTagUiProps(t)

  return <PerTag color={tagColor(type)}>{tagName(type)}</PerTag>
}
